module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-25.1691729f.png";